import { FullViewComponent } from '../../views/full-view/full-view.component';
import { BaseMenuEntry } from './base-view-entry';

export class DocumentFullViewEntry extends BaseMenuEntry {
  constructor() {
    super(FullViewComponent, 500);
  }
}
